// extracted by css-extract-rspack-plugin
export default {"input":"fX75G","srOnly":"cBqvK"};